<template>
  <div>
    <span class=" block mb-0.1rem">请选择或输入文件地址</span>
    <el-input
  :placeholder="selectvalue"
  v-model="filterText">
</el-input>
<div class="max-h-1rem overflow-auto h-1rem mb-0.1rem" style="border: 1px solid #ddd;">
<el-tree
  class="filter-tree"
  :data="filelist"
  :props="defaultProps"
  accordion
  show-checkbox
  :check-strictly="true"
  node-key="path"
  :check-on-click-node="true"
  @check="handleCheck"
  :filter-node-method="filterNode"
  ref="tree"
  v-loading="flage"
  >
</el-tree>
</div> 
<div class="h-0.2rem">
  <span ></span>
  <el-button class="float-right " type="primary" @click="selectFn">确定</el-button>
</div>
  </div>
</template>

<script>
  export default {
    props:['type'],
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    created(){
     
    },
    data() {
      return {
        selectvalue:'请选择或输入文件地址',
        filterText: '',
        filelist: [],
        defaultProps: {
          children: 'children',
          label: 'label',

        },
        flage:true,
        selectedKey: null,
        newCheckedKeys:null,
      };
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      selectFn(){
        if(this.selectedKey){
          this.$emit('finish',this.selectvalue)
        }
      },
      //节点切换事件data为选中项
      handleCheck(data, checked) {
        // console.log(checked);
        
        if(data.label!='共享存储'){
          this.filterText=''
          if(this.selectvalue==data.path){
            this.selectvalue=''
            return
          }
          this.selectvalue=data.path
        }
      if (checked) {
        // 获取所有已勾选的节点

        this.selectedKey = data.path; 
        const allCheckedKeys = this.$refs.tree.getCheckedNodes();
         this.newCheckedKeys = allCheckedKeys.filter(key => key.path === this.selectedKey);
        allCheckedKeys.forEach((node) => {
          this.$refs.tree.setChecked(node, false);
        })
        this.$refs.tree.setChecked(this.newCheckedKeys[0], true);

      }else {
        // 如果当前项被取消勾选，清空 selectedKey
        if (data.path === this.selectedKey) {
          this.selectedKey = null;
        }
      }
    },
    processData(node) {
      // 首先检查 subdirectory 是否存在
      if (node.subdirectory) {
        // 将 subdirectory 替换为 children
        node.children = node.subdirectory;
        // 删除原来的 subdirectory 属性
        delete node.subdirectory;

        // 递归处理每一个子项
        node.children.forEach(this.processData);
      }
    },
  //获取模型地址
    getShareFileList(e){
      this.$api.storage.getShareFileList(e).then((res) => {
        this.processData(res.data.list)
        this.filelist=[]
        this.filelist.push(res.data.list)
        this.flage=false
      })
    },
    //被父级删除按钮调用的事件
    close(){
     this.selectvalue=''
     const allCheckedKeys = this.$refs.tree.getCheckedNodes();
     allCheckedKeys.forEach((node) => {
          this.$refs.tree.setChecked(node, false);
        })
    }
    },
  };
</script>

<style lang="scss" scoped>

::v-deep .el-tree {
        .el-tree-node {
          .is-leaf + .el-checkbox .el-checkbox__inner {
            display: inline-block;
            position: relative;
          }
          .el-checkbox{
                position: absolute;
                right: 50px;
          }
          .el-checkbox .el-checkbox__inner {
              position: absolute;
              display: none;
              
          }
        }
      }

</style>